import React from "react";
import ReactDOM from "react-dom";
import NewQuoteForm from "../src/forms/NewQuoteForm/NewQuoteForm";

document.addEventListener("DOMContentLoaded", () => {
  const node = document.getElementById("new_quote");
  const props = JSON.parse(node.getAttribute("data"));
  ReactDOM.render(
    <NewQuoteForm {...props} />,
    document.getElementById("quote-form")
  );
});
